import clsx from 'clsx';
import type { IconProps } from '../components/types.js';
import { fgTone } from '../utils/style/tone.js';
const displayName = 'IconCheck';
/** Renders an SVG icon. */
const SvgCheck = ({ size, 'aria-hidden': ariaHidden, tone, UNSAFE_className, UNSAFE_style, ...rest }: IconProps) => {
  const props = {
    ...rest,
    'aria-hidden': ariaHidden ?? (rest['aria-label'] == null && rest['aria-labelledby'] == null),
    className: clsx('cim-icon', tone && fgTone(tone), UNSAFE_className),
    style: UNSAFE_style,
    width: size != null ? size + 'px' : '1em',
    height: size != null ? size + 'px' : '1em',
  };
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" data-icon="true" fill="currentColor" {...props}>
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="M26.64 7.232a1 1 0 0 1 .128 1.409l-12.5 15a1 1 0 0 1-1.475.067l-7.5-7.5a1 1 0 1 1 1.414-1.415l6.726 6.726L25.232 7.36a1 1 0 0 1 1.408-.128"
      />
    </svg>
  );
};
SvgCheck.displayName = displayName;
export default SvgCheck;
